<template>
  <div class="title-component tva-row">
    <div class="title-container tva-col-md-offset-3 tva-col-md-6 tva-col-sm-offset-2 tva-col-sm-8 tva-col-xs-12">
      <h3 class="title" v-html="content">{{content}}</h3>
      <div :class="['blue-box', {'active': active}]"></div>
      <div :class="['white-box', {'active': active}]"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content", "active"]
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";

.title-component {
  user-select: none;
  .title-container {
    position: relative;
    .blue-box {
      position: absolute;
      top: 40%;
      left: -70px;
      background: $terna-light-blu;
      height: 50px;
      width: 0;
      z-index: -2;
      transition: all 1s ease;
      &.active {
        width: 600px;
      }
    }
    .white-box {
      position: absolute;
      top: 40%;
      left: -70px;
      background: white;
      height: 50px;
      width: 0;
      z-index: -1;
      transition: all 2s ease;
      &.active {
        width: 600px;
      }
    }
  }
}
@media (max-width: 768px) {
  .title-component {
    .title-container h3 {
      margin-top: 0;
    }
  }
}
</style>
